import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Select, Textarea } from '@mantine/core'
import { DateTimePicker } from '@mantine/dates'
import LoadingData from '../../../../ui/LoadingData'
import { getAllStatusesList } from '../../../../../services/status'
import { updateOrderHistory } from '../../../../../services/orders'
import { validation } from '../../../../../plugins/validation'
import dayjs from 'dayjs'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  status_id: null,
  date: null,
  notes: null
}

const formValidation = {
  status_id: {
    isError: false,
    message: ''
  },
  date: {
    isError: false,
    message: ''
  },
}

const FormAdjustOrderHistory = ({ dataHistory, onCloseForm, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [statusList, setStatusList] = useState([])

  const handleUpdateOrderHistory = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      status_id: form.status_id,
      date: form.date
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payload = {
      order_id: form.order_id,
      status_id: Number(form.status_id),
      date: dayjs(form.date).format('YYYY-MM-DD HH:mm:ss'),
      notes: form.notes
    }
    try {
      const response = await updateOrderHistory(dataHistory.id, payload)
      if (response.success) {
        onCloseForm()
        reloadList()
        notificationSuccess('Update Order History Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order History Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetOrderStatusList = async () => {
    setLoadingStatus(true)
    const params = {
      'filter[status_type][is]': 2
    }
    try {
      const response = await getAllStatusesList(params)
      const responseData = response.data
      const remapStatus = responseData.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)
        }
      })
      setStatusList(remapStatus)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatus(false)
    }
  }

  useEffect(() => {
    handleGetOrderStatusList()
    if (dataHistory) {
      handleSetForm(dataHistory)
    }
  }, [dataHistory])

  const handleSetForm = (val) => {
    const detail = {
      order_id: val.order_id,
      status_id: `${val.status_id}`,
      date: new Date(val.date),
      notes: val.notes
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const loadData = () => {
    return (
      <Box>
        <Box mb='md'>
          <Select
            name='status_id'
            value={formData.status_id}
            label='Order Status'
            data={statusList}
            onChange={(val) => handleChangeForm('status_id', val)}
            error={validationForm.status_id.isError ? `${validationForm.status_id.message}` : ''}
            size='xs'
            allowDeselect={false}
            withAsterisk
          />
        </Box>
        <Box mb='md'>
          <DateTimePicker 
            name='date'
            label="Date" 
            placeholder="Pick date and time"
            value={formData.date}
            onChange={(val) => handleChangeForm('date', val)}
            error={validationForm.date.isError ? `${validationForm.date.message}` : ''}
            size='xs'
            withAsterisk
            withSeconds
            valueFormat="DD-MM-YYYY h:mm:ss A"
            clearable
          />
        </Box>
        <Box mb='md'>
          <Textarea
            name='notes'
            label="Notes"
            placeholder="Input notes"
            value={formData.notes}
            onChange={(val) => handleChangeForm('notes', val.target.value)}
            size='xs'
            autosize
            minRows={4}
            maxRows={4}
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => handleUpdateOrderHistory(formData)}>Update</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingStatus ? <LoadingData /> : loadData()}
    </Box>
  )
}

export default FormAdjustOrderHistory